import { useTranslation } from 'react-i18next'
import { useAPI, useOrganization, useStore, useMe } from 'global'
import { toast } from 'react-toastify'
import { StoreEdit, openModal, closeModal } from 'components'
import Screen from './screen.jsx'

export default function StoreDetails() {
  const { t } = useTranslation(null, { useSuspense: false })
  const api = useAPI()
  const { organization: org } = useOrganization()
  const storeData = useStore()
  const { store, updateStore } = storeData
  const { me: { canEditStore, canProvision } = { } } = useMe()

  let keyExpirationInterval = null
  let root = org
  let usingOrgSettings = !org?.localKeyExpirationAllowed || store?.keyExpTimeIntervalEnabled == null
  if (!usingOrgSettings) root = store
  if (root?.keyExpTimeIntervalEnabled) keyExpirationInterval = root?.keyExpTimeInterval

  const onProvision = hubID => {
    if (!hubID) return toast.error(t('error.provisionMode'))
    api.startProvisionMode(store?.id, hubID).then(()=>{
      toast.success(t('success.provisionMode'))
    }).catch(()=>{
      toast.error(t('error.provisionMode'))
    })
  }

  const onEditFinished = newStoreData => {
    if (newStoreData) {
      const { store: newStore, address, region } = newStoreData
      updateStore?.(newStore, address, region) // When editing the existing store context, make sure to update the context
    }
    closeModal()
  }

  const onEdit = () => openModal(<StoreEdit storeData={storeData} organization={org} onFinish={onEditFinished} />)

  const screenProps = {storeData, onProvision, onEdit, canEditStore, canProvision, keyExpirationInterval, usingOrgSettings}
  return <Screen { ...screenProps } />
}
